import { DRAW_MODE_NAMES } from 'shared/stores/annotations/consts';
import { actionProvider, installable } from 'shared/stores/core/decorators';

const DRAW_MODE_LOCK = {lockOwner: 'us:annotations', displayKey: 'annotations.ui-title', modes: DRAW_MODE_NAMES};

// Locks down the drawing tools when certain events happen. These events are derived from legacy code and the original
// rationale for each particular event is unknown. Best guess is documented.
@installable
@actionProvider
export class AnnotationsLockdownService {
  USCOPE_BIND_EVENTS ({dispatch}, uScope) {
    watch('uscope:enter-lockdown');
    watch('uscope:exit-lockdown');

    function watch (event) {
      uScope.events.on(event, () => { dispatch('EVALUATE_DRAW_PERMISSIONS'); });
    }
  }

  remap = {
    // This is useful for preventing annotations from being drawn when in conferencing
    IMAGE_SELECTED: 'EVALUATE_DRAW_PERMISSIONS',

    // Unsure why we would need to do either of these; see comment at beginning.
    DRAW_MODE_COMPLETE: 'EVALUATE_DRAW_PERMISSIONS',
    REGION_DELETED: 'EVALUATE_DRAW_PERMISSIONS'
  };

  EVALUATE_DRAW_PERMISSIONS ({dispatch, get}) {
    // Evaluate whether drawing modes can be enabled
    const {uScope} = get('USCOPE');
    const action = uScope.canAnnotate() ? 'UNLOCK_DRAW_MODES' : 'LOCK_DRAW_MODES';

    dispatch(action, DRAW_MODE_LOCK);
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/annotations/AnnotationsLockdownService.js